export class EmailOnlyContact {
    email;
    type = 'email';
    constructor(email) {
        this.email = email;
    }
    get name() {
        return this.email;
    }
    get shortName() {
        return this.email;
    }
    getAssigneeId() {
        return `${this.email}`;
    }
}
